export default {
  choose: {
    title: 'Poista {{name}} omistajan roolista',
    title_no_owner: 'Valitse omistaja ravintolalle {{restaurant}}',
    description:
      'Valitse, kuka ottaa vastuun henkilöltä {{name}}, tai jätä {{restaurant}} toistaiseksi ilman omistajaa.',
    description_no_owner: 'Ravintolalla {{restaurant}} ei ole omistajaa. Valitse joku tiimistä tai uusi henkilö.',
    new_owner: 'Uusi omistaja',
    previous_owner: '{{name}} muutoksen jälkeen',
  },
  options: {
    team: {
      title: 'Joku tiimistä',
      loading: 'Ladataan tiimiä…',
      description_one: 'Kuka tahansa operaattori tai työntekijä, {{count}} henkilö.',
      description_other: 'Kuka tahansa operaattori tai työntekijä, {{count}} henkilöä.',
      empty: 'Tiimissä ei ole vielä ketään muuta.',
      search: 'Hae tiimistä nimellä tai sähköpostilla',
      no_match: 'Kukaan tiimistä ei vastaa hakua “{{query}}”.',
    },
    new: {
      title: 'Joku uusi',
      description: 'Hänestä tulee heti omistaja, ja hän saa kirjautumistunnuksensa sähköpostitse.',
    },
    none: {
      title: 'Ei omistajaa toistaiseksi',
      description: 'Valitse omistaja myöhemmin. Siihen asti ravintolalla {{restaurant}} ei ole omistajaa.',
    },
    keep: {
      title: 'Jää tiimiin operaattorina',
      description: 'Säilyttää pääsyn ravintoloihin, joita hän hallinnoi nyt.',
    },
    remove: {
      title: 'Poistetaan tiimistä',
      description: 'Menettää pääsyn hallintapaneeliin heti.',
    },
  },
  roles: {
    operator: 'Operaattori',
    employee: 'Työntekijä',
  },
  fields: {
    first_name: 'Etunimi',
    last_name: 'Sukunimi',
    email: 'Sähköposti',
  },
  email_errors: {
    invalid_email: 'Anna kelvollinen sähköpostiosoite, esim. nimi@example.com.',
    email_is_owner: '{{name}} on jo omistaja.',
    email_is_manager: '{{name}} on jo tiimissä.',
    email_taken:
      'Tiimin ulkopuolinen henkilö kirjautuu jo tällä sähköpostiosoitteella. Käytä toista sähköpostiosoitetta.',
  },
  confirm: {
    title: 'Poistetaanko {{name}} omistajan roolista?',
    title_no_owner: 'Tehdäänkö henkilöstä {{name}} omistaja?',
    description_both: 'Molemmat muutokset tehdään yhtä aikaa. Jos toinen epäonnistuu, mikään ei muutu.',
    description: 'Tarkista muutos ennen vahvistamista.',
  },
  summary: {
    none: 'Ravintolalla <b>{{restaurant}}</b> ei ole omistajaa, ennen kuin valitset sellaisen. Kaikki omistajaa vaativat toimet odottavat siihen asti.',
    new: '<b>{{name}}</b> tulee heti ravintolan {{restaurant}} omistajaksi.',
    email:
      'Kirjautumistunnukset lähetetään osoitteeseen <b>{{email}}</b>. Tarkista osoite: jokainen, jolla on tämä sähköposti, voi kirjautua omistajana.',
    team: '<b>{{name}}</b> tulee ravintolan {{restaurant}} omistajaksi.',
    group_access: 'Omistajana hän saa pääsyn kaikkiin ryhmän {{group}} ravintoloihin, mikä voi olla enemmän kuin nyt.',
    keep: '<b>{{name}}</b> jää tiimiin operaattorina.',
    remove: '<b>{{name}}</b> poistetaan tiimistä, eikä hän voi enää kirjautua sisään.',
  },
  error: {
    title: 'Omistajan vaihtaminen epäonnistui.',
    description: 'Mitään ei muutettu. Yritä uudelleen tai ota yhteyttä tukeen, jos ongelma jatkuu.',
  },
  buttons: {
    continue: 'Jatka',
    cancel: 'Peruuta',
    back: 'Takaisin',
    remove_as_owner: 'Poista omistajan roolista',
    make_owner: 'Tee omistajaksi',
    saving: 'Tallennetaan…',
    try_again: 'Yritä uudelleen',
    choose_instead: 'Valitse sen sijaan {{name}}',
    invite_instead: 'Kutsu sen sijaan uusi henkilö',
  },
};
